var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('top-panel'),_c('h3',{staticClass:"mt-5"},[_vm._v("Page not found")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }